import { Button, Stack } from '@mui/material'
import { BarcodeInspectionType } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { useLabelFormContext } from '../LabelForm/LabelFormContext'
import { AlphanumericValue } from './AlphanumericValue'
import { useAreaFormContext } from './AreaFormContext'
import { AreaName } from './AreaName'
import { AreaTypeSelect } from './AreaTypeSelect'
import { BarcodeValue } from './BarcodeValue'
import { ExpirationFieldGroup } from './expiration'
import { FloatingFooter } from './FloatingFooter'

export const AreaForm: FC = () => {
  const { cancelEditing } = useLabelFormContext()
  const { formValues, handleSubmit, handleSave } = useAreaFormContext()

  const showBarcodeValue =
    formValues.type === 'barcode' &&
    formValues.barcodeInspectionType === BarcodeInspectionType.MATCH

  return (
    <Stack sx={{ height: '100%' }} aria-label="検査箇所Form">
      <Stack spacing={4} p={2} overflow="auto">
        <Stack spacing={2}>
          <AreaName />
          <AreaTypeSelect />
        </Stack>
        {formValues.type === 'expiration' && <ExpirationFieldGroup />}
        {formValues.type === 'alphanumeric' && <AlphanumericValue />}
        {showBarcodeValue && <BarcodeValue />}
      </Stack>

      <FloatingFooter>
        <Button variant="outlined" onClick={cancelEditing}>
          キャンセル
        </Button>
        <Button variant="contained" onClick={handleSubmit(handleSave)}>
          保存
        </Button>
      </FloatingFooter>
    </Stack>
  )
}
